import { FeedDistributionScenarios } from '../../apps/feedlotManager/modules/feed/manualFeedEntry/interfaces';

export const ManualFeedEntryConstants = {
    labels: {
        date: 'Select Date',
        ration: 'Ration',
        pen: 'Pen',
        weight: 'Weight (lbs)',
        totalHeadCount: 'Total Hd',
        totalEstimatedHdCount: 'Est. Total Head Count',
        estimatedHeadCount: 'Est. Hd Count',
        noContent: 'No Content Found!',
        incorrectInformation:
            'If pen information is incorrect, please update the cattle records.',
        penInfo: 'Pen Info',
        feed1: 'Feed 1',
        feed2: 'Feed 2',
        feed3: 'Feed 3',
        feed4: 'Feed 4',
        totalFeed: 'Total Feed',
        feedCall: 'Feed Call',
        lot: 'Lot',
        eodHd: 'EOD Hd',
        movements: 'Movements',
        movementType: 'Movement Type',
        hd: 'Hd',
        fromTo: 'From/To',
        headCountForFeedings: 'Head Count for Feedings',
    },
    checkbox: {
        adjustingFeedEntries: 'Adjust Existing Feed Entries',
    },
    penInfoHeader: ['Lot#', 'Hd Count', 'Sex', 'Owner'],
    //delete estHdCountModalHeader and rename estHdCountModalHeaderFM241481 during 241841 cleanup
    estHdCountModalHeader: ['Lot#', 'Hd Count', 'Estimated Hd Count'],
    estHdCountModalHeaderFM241481: ['Lot#', 'Estimated Hd Count'],

    apiFields: {
        date: 'date',
        rationId: 'rationId',
        penId: 'penId',
        weight: 'weight',
        estimatedHeadCount: 'estimatedHeadCount',
        name: 'name',
        lotId: 'lotId',
        lotPenId: 'lotPenId',
        hdCount: 'hdCount',
        createdDateTime: 'createdDateTime',
        feed1: 'feed1',
        feed2: 'feed2',
        feed3: 'feed3',
        feed4: 'feed4',
        totalFeed: 'totalFeed',
        feedCall: 'feedCall',
    },
    placeholders: {
        weight: 'Enter lbs',
        estimatedHeadCount: 'Enter Est. Hd Count',
        feed1: 'Feed 1',
        feed2: 'Feed 2',
        feed3: 'Feed 3',
        feed4: 'Feed 4',
        totalFeed: 'Total Feed',
        feedCall: 'Feed Call',
    },
    mandatoryfeedEntryRationDetailsFields: ['date', 'rationId'],
    mandatoryfeedEntryPensDetailsFields: ['penId', 'estimatedHeadCount'],
    mandatoryfeedEntryPensDetailsOldFields: [
        'penId',
        'weight',
        'estimatedHeadCount',
    ],
    staticOptions: {
        lots: [
            {
                name: 'Select Lot',
                id: 0,
            },
        ],
    },
    button: {
        addRow: 'Add Row',
        penInfo: 'View Pen Info',
        estHdCount: 'Est. Head Count',
        cancel: 'Cancel',
        submit: 'Submit',
        okay: 'Okay',
    },
    dropDownName: {
        rations: {
            rationId: 'rationId',
            name: 'name',
        },
        pens: {
            penId: 'penId',
            name: 'name',
        },
    },
    successMessage: {
        create: 'Manual Feed Entry Created Successfully.',
        update: 'Manual Feed Entry Updated Successfully.',
        delete: 'Manual Feed Entry Row Deleted Successfully',
    },
    confirmationMessage: {
        delete: 'Are you sure you want to delete this feed entry ?',
    },
    errorMessage: {
        invoiceAlreadyGenerated:
            'One or more of these records have a date that is within a generated billing period. To make adjustments to the invoice, please submit a miscellaneous charge or credit.',
        noTotalHeadCount:
            'One or more of these records does not have a total head count.',
        notAllLotsOpen: 'Feed entries cannot be assigned to a closed lot.',
        backdatedEntry:
            "Cannot submit a backdated Manual Feed Entry prior to the effective date of the Ration.  Please make sure your Ration's effective date is prior to the date of your MFE.",
        fedCanNotLessThanIpadDeilvery:
            "You're trying to reduce a feed entry that was submitted via iPad. To edit iPad feedings, please use the Feed Status page. Manual Feed Entry only allows increasing or editing MFE-only entries.",
        incompleteFeedDistribution: 'Feed Distribution Incomplete',
        feedDistributionDiscrepancy:
            'At least one feeding number has no head assigned. You must select at least one record for every feeding number with feed before submitting.',
    },
    errorTitle: {
        fedCanNotLessThanIpadDeilveryTitle: 'Unable to Decrease Feed Entry',
    },
    warningMessage: {
        invoiceAlreadyGenerated: `Note: One or more of the lots associated with these pens
                        has had invoices generated for this date. Changes to
                        feed charges for those lots must be submitted as a miscellaneous feed
                        charge or credit.`,
    },
    cancellationMessage:
        'Are you sure you want to cancel this feed entry? All information not submitted will be lost.',
    maxManualFeedEntries: 30,
    totalMFEFeedingFields: 4,
    createdSource: {
        mfe: 'MFE',
        ipadApp: 'FeedingApp',
    },
    feedDistributionScenarios: {
        [FeedDistributionScenarios.HasNoEstimatedHead]: {
            message: `Feed charges are based on cattle present at the feed call. Movements won't affect charges unless feed call is updated.\nSelect "Adjust Feed Distribution" to change this.`,
            buttonLabel: 'Adjust Feed Distribution',
            isTableDisabled: true,
        },
        [FeedDistributionScenarios.CreatingDistributionWithNoEstimatedHead]: {
            message:
                'You are editing feed distribution. Do you want to revert to the previous feed distribution?',
            buttonLabel: 'Revert to Previous Distribution',
            isTableDisabled: false,
        },
        [FeedDistributionScenarios.HasEstimatedHead]: {
            message:
                'This pen has a feed call with an estimated head count. Making changes to the feed charges will override the estimated head. Would you like to proceed with the changes?',
            buttonLabel: 'Edit Feed Distribution',
            isTableDisabled: true,
        },
        [FeedDistributionScenarios.CreatingDistributionWithEstimatedHead]: {
            message:
                'You are now editing the feed distribution based on the actual head count. Do you want to cancel these changes and return to the original estimated head count?',
            buttonLabel: 'Revert to Estimated Head',
            isTableDisabled: false,
        },
        [FeedDistributionScenarios.HasPreviouslySavedDistribution]: {
            message:
                'A feed adjustment was already made for this pen. Would you like to edit the previous adjustment?',
            buttonLabel: 'Edit Feed Distribution',
            isTableDisabled: true,
        },
        [FeedDistributionScenarios.UpdatingDistribution]: {
            message:
                'You are editing feed distribution. Do you want to revert to the previous feed distribution?',
            buttonLabel: 'Revert to Previous Distribution',
            isTableDisabled: false,
        },
        [FeedDistributionScenarios.PreviouslySavedDistributionIsOutOfSync]: {
            message:
                'New cattle movements have been recorded since your last feed distribution adjustment. Editing the distribution will include these new movements.',
            buttonLabel: 'Edit Feed Distribution',
            isTableDisabled: true,
        },
        [FeedDistributionScenarios.RevertToOutOfSync]: {
            message:
                'You are editing feed distribution. Do you want to revert to the previous feed distribution?',
            buttonLabel: 'Revert to Previous Distribution',
            isTableDisabled: false,
        },
        [FeedDistributionScenarios.NoCattle]: {
            message: `There were no cattle in this pen on the selected day. Feed cannot be distributed.`,
            buttonLabel: '',
            isTableDisabled: true,
        },
        [FeedDistributionScenarios.NoMovements]: {
            message: `Feed distribution cannot be adjusted because there are no cattle movements and only one lot in the pen.`,
            buttonLabel: '',
            isTableDisabled: true,
        },
    },
    doNotIncludeDistribution: [
        FeedDistributionScenarios.HasNoEstimatedHead,
        FeedDistributionScenarios.HasEstimatedHead,
        FeedDistributionScenarios.NoCattle,
        FeedDistributionScenarios.NoMovements,
        FeedDistributionScenarios.PreviouslySavedDistributionIsOutOfSync,
    ],
    revertToCurrentDistribution: [
        FeedDistributionScenarios.CreatingDistributionWithNoEstimatedHead,
        FeedDistributionScenarios.CreatingDistributionWithEstimatedHead,
        FeedDistributionScenarios.UpdatingDistribution,
        FeedDistributionScenarios.RevertToOutOfSync,
    ],
};
